<mat-card class="contact-card">
    <mat-card-header>
      <mat-card-title>Contact EB</mat-card-title>
    </mat-card-header>

    <mat-card-actions>
      <a mat-button href="/contact">Here</a>
    </mat-card-actions>
  </mat-card>